import team_img_1 from "../../assets/images/team/team-1.jpg"
import team_img_2 from "../../assets/images/team/team-2.jpg"
import team_img_3 from "../../assets/images/team/team-3.jpg"
import team_img_4 from "../../assets/images/team/team-4.jpg"
import team_img_5 from "../../assets/images/team/team-5.jpg"


export const partnersData = [
    {
        id: 1,
        src: team_img_1,
        name: "SPS CPR LLC",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/spscpr",
                icon: 'ri-facebook-circle-line'
            },
            {
                id: 2,
                link: "https://spscpr.com/",
                icon: 'ri-global-line'
            },
            {
                id: 3,
                 link: "tel:+16017401137",
                icon: 'ri-phone-line'
            },
           

        ],
        position: "Owner, Shane Saucier"
    },
    {
        id: 2,
        src: team_img_2,
        name: "Operations Practical Solutions LLC",
        social_media: [
            {
                id: 1,
                link: "https://www.facebook.com/profile.php?id=61577889663024",
                icon: 'ri-facebook-circle-line'
            },
          
            {
                id: 2,
                link: "tel:+16016741103",
                icon: 'ri-phone-line'
            },

        ],
        position: "Owner, Mitch Anderson"
    },
    {
        id: 3,
        src: team_img_4,
        name: "Brent Sandifer",
        social_media: [
           
        

        ],
        position: "Law Enforcement Officer (Currently a Criminal Investigator), Former United States Army Military Police, and Certified Instructor with Mississippi Board of Law Enforcement Standards and Training "
    },
    
    
    
    
]